import { Type, ajax, Dom, Event, Loc, isNodeHidden } from "main.core";
import {
 PopupMenu,
 PopupMenuWindow,
 PopupWindowButton,
 PopupWindow,
} from "main.popup";

export class RegionChoose {
 constructor(id) {
  this.name = "RegionChoose";
  this.controllerName = "vsbx:regions.ChooseComponentController.";
  this.getRegion();

  this.rootId = id;
  this.rootDropDownId = "regions_choose_component_dropdown";
  this.selectRegionID = "regon_choose_select-city__modal";
  this.selectRegionOverlayID = "regon_choose_modal__overlay";

  this.questionRegionId = null;
  this.loctionList = null;

  this.root = document.getElementById(this.rootId);
  this.rootDropDown = document.getElementById(this.rootDropDownId);
  this.selectRegion = document.getElementById(this.selectRegionID);

  this.setEvents();
 }

 getName() {
  return this.name;
 }

 getEntity(parent, entity, all = false) {
  if (!parent || !entity) {
   return null;
  }
  if (all) {
   return parent.querySelectorAll('[data-entity="' + entity + '"]');
  }
  return parent.querySelector('[data-entity="' + entity + '"]');
 }

 setEvents() {
  let self = this;
  this.root.addEventListener("click", () => this.onShowALLRegions());
  BX.ready(() => {
   document.querySelectorAll('.btn-region-selected').forEach((el) => {
    el.addEventListener("click", () => self.onShowALLRegions());
   });
  });

 }

 onSetRegion(regionId) {
  if (regionId)
   ajax
    .runAction(this.controllerName + "setRegion", {
     data: { regionId: regionId },
    })
    .then(
     (res) => res.data.actions.forEach((i) => this[i](res.data)),
     (err) => console.log(err)
    );
 }

 dropDownShow(action) {
  let self = this;
  if (!this.dropDownShowPopUp) {
   this.dropDownShowPopUp = new PopupWindow({
    className: "select-city-dropdown-wrap",
    bindElement: this.root,
    titleBar: Loc.getMessage("VS_REGION_TITLE_SELECT_CITY"),
    content: "",
    autoHide: true,
    closeByEsc: true,
    angle: true,
    offsetLeft: 30,
    // offsetTop: 5,
    animation: "fading-slide",
    buttons: [
     new PopupWindowButton({
      text: Loc.getMessage("VS_REGION_BTN_TEXT_NO"), // текст кнопки
      id: "no-btn", // идентификатор
      className: "btn btn-outline-primary btn-sm", // доп. классы
      events: {
       click: function () {
        self.onShowALLRegions();
        this.popupWindow.close();
       },
      },
     }),
     new PopupWindowButton({
      text: Loc.getMessage("VS_REGION_BTN_TEXT_OK"),
      id: "yes-btn",
      className: "btn btn-primary btn-sm",
      events: {
       click: function () {
        this.popupWindow.close();
        self.onSetRegion(self.questionRegionId);
       },
      },
     }),
    ],
   });
  }
  if (action) {
   if (!isNodeHidden(this.root)) this.dropDownShowPopUp.show();
  } else {
   this.dropDownShowPopUp.close();
  }
 }

 onShowALLRegions() {
  if (this.loctionList !== null) {
   return this.SHOW_SELECT_REGIONS(this.loctionList);
  }

  ajax.runAction(this.controllerName + "showLocations", {}).then(
   (res) => res.data.actions.forEach((i) => this[i](res.data)),
   (err) => console.log(err)
  );
 }

 getRegion() {
  const query = new URLSearchParams(window.location.search);
  this.removeRegionGetParams(query);
  ajax
   .runAction(this.controllerName + "getRegion", {
    data: { redirectRegionId: query.get("redirectRegionId") },
   })
   .then(
    (res) => res.data.actions.forEach((i) => this[i](res.data)),
    (err) => console.log(err)
   );
 }
 _searchCity(e) {
  this._renderList();
 }
 _setGeo(e) {
  let self = this;
  BX.loadScript(
   "https://api-maps.yandex.ru/2.0-stable/?load=package.standard&lang=ru-RU",
   function () {
    ymaps.ready(function () {
     self._nameInput.value = ymaps.geolocation.city;
     self._searchCity();
    });
   }
  );
 }
 renderSelectRegion() {
  let node = Dom.create("DIV", {
   attrs: {
    class: "container-list-region-city",
   },
  });
  let label = Dom.create("LABEL", {
   attrs: {
    class: "form-label w-100 mb-0",
   },
   html:
    "<span>" + Loc.getMessage("VS_REGION_LABEL_INPUT_SEARCH") + "</span>",
  });
  this._nameInput = Dom.create("INPUT", {
   attrs: {
    class: "form-control",
    autocapitalize: "off",
    autocorrect: "off",
    spellcheck: "false",
    autocomplete: "new-password",
    placeholder: Loc.getMessage("VS_REGION_PLACEHOLDER_INPUT_SEARCH"),
   },
   props: {
    type: "text",
    maxlength: "255",
    size: "30",
   },
   events: {
    input: BX.delegate(this._searchCity, this),
   },
  });
  label.appendChild(this._nameInput);

  let autoGeo = Dom.create("A", {
   attrs: {
    class: "link fs-12",
    href: "javascript:void(0);",
   },
   text: Loc.getMessage("VS_REGION_TXT_DETECT_AUTO"),
   events: {
    click: BX.delegate(this._setGeo, this),
   },
  });
  label.appendChild(autoGeo);
  node.appendChild(label);
  this._listElement = Dom.create("DIV", {
   attrs: {
    class:
     "list-region-city row row-cols-2 row-cols-md-2 row-cols-lg-4 row-cols-xl-5 row-cols-xxl-6",
   },
  });
  node.appendChild(this._listElement);
  return node;
 }
 onSelectRegionShow(action) {
  let self = this;
  if (!self.popSelectRegion) {
   self.popSelectRegion = new BX.PopupWindow({
    className: "select-region-pop-list",
    titleBar: Loc.getMessage("VS_REGION_TITLE_POP_SELECT_REGION"),
    content: self.renderSelectRegion(),
    autoHide: false,
    closeByEsc: true,
    overlay: { backgroundColor: "#000", opacity: "80" },
    closeIcon: true,
    animation: "fading-slide",
    offsetTop: 0,
    events: {
     onPopupShow: function () {
      // Событие при показе окна
      Dom.adjust(document.body, { style: { overflow: "hidden" } });
     },
     onPopupClose: function () {
      // Событие при закрытии окна
      var t = bootstrap.Offcanvas.getOrCreateInstance('#menu_catalog');
      if (!t || !t._isShown)
      Dom.adjust(document.body, { style: { overflow: "" } });
     },
    },
   });
   setTimeout(() => {
    Dom.adjust(self.popSelectRegion.popupContainer, {
     style: { position: "fixed", top: "20px" },
    });
   }, 100);
  }
  if (action) {
   self.popSelectRegion.show();
  } else {
   self.popSelectRegion.close();
  }
 }

 SHOW_REGION_NAME({ currentRegionName }) {
  const element = this.getEntity(document, "select-city__block__text-city", true);
  if (element) element.forEach((el) => { el.innerText = currentRegionName; });
 }

 SHOW_QUESTION({ currentRegionName, currentRegionId }) {
  this.questionRegionId = currentRegionId;
  this.dropDownShow(true);
  this.dropDownShowPopUp.setContent(currentRegionName);
 }

 CONFIRM_DOMAIN({ currentRegionName }) {
  this.dropDownShow(false);
  const element = this.getEntity(document, "select-city__block__text-city", true);
  if (element) element.forEach((el) => { el.innerText = currentRegionName; });
 }
 _selected(e) {
  this.onSetRegion(e.target.dataset.regionId);
  this.onSelectRegionShow(false);
 }
 _getListRegion() {
  if (this.loctionList && this._nameInput.value.length) {
   let m = this.loctionList.filter((i) => {
    return new RegExp(this._nameInput.value, "i").test(i.CITY_NAME);
   });
   return m;
  }
  return this.loctionList;
 }
 _renderList() {
  let arr = this._getListRegion();
  if (arr == null) {
   return;
  }
  Dom.clean(this._listElement);
  let maxItemCount = 40;
  let countArr = Object.keys(arr).length;
  let bLabel = this._nameInput.value == "" && countArr > maxItemCount;
  let i = 1;
  let labelPopular = false;
  let labelAllCity = false;
  let arCityNameAll = {};
  for (let ii = 0, l = arr.length; ii < l; ++ii) {
   let item = arr[ii];
   if (bLabel) {
    if (i <= maxItemCount) {
     if (!labelPopular) {
      this._listElement.append(
       Dom.create("DIV", {
        attrs: {
         class: "col list-label list-popular-col fw-bold w-100",
        },
        text: Loc.getMessage("VS_REGION_LABEL_LIST_POPULAR"),
       })
      );
      labelPopular = true;
     }
    } else {
     if (!labelAllCity) {
      this._listElement.append(
       Dom.create("DIV", {
        attrs: {
         class: "col list-label list-all-col fw-bold w-100",
        },
        text: Loc.getMessage("VS_REGION_LABEL_LIST_ALL"),
       })
      );
      labelAllCity = true;
     }
    }
   }
   let cityName = item.CITY_NAME;
   if (labelAllCity) {
    let arName = cityName.split("");
    if (!arCityNameAll[arName[0]]) {
     arCityNameAll[arName[0]] = true;
     arName[0] = "<b>" + arName[0] + "</b>";
     cityName = arName.join("");
    }
   }
   let element = Dom.create("A", {
    attrs: {
     class:
      "col link" +
      (labelAllCity ? " all-city" : "") +
      (labelPopular && !labelAllCity ? " popular-city" : ""),
     href: "javascript:void(0);",
     "data-region-id": item.ID,
    },
    html: cityName,
    events: {
     click: BX.delegate(this._selected, this),
    },
   });
   this._listElement.append(element);
   i++;
  }
 }
 SHOW_SELECT_REGIONS({ allRegions, allRegionsNew }) {
  this.onSelectRegionShow(true);
  if (this.loctionList !== null) {
   return;
  }
  if (!allRegionsNew && type.isPlainObject(allRegions)) {
   let arr = [];
   for (let id in allRegions) {
    arr.push({ ID: id, CITY_NAME: allRegions[id] });
   }
   this.loctionList = arr;
  } else if (!allRegionsNew) {
   this.loctionList = allRegions;
  } else {
   this.loctionList = allRegionsNew;
  }

  this._renderList();
 }

 REDIRECT_TO_SUBDOMAIN({ currentRegionCode, currentRegionId }) {
  const hostName = window.location.hostname;
  const protocol = window.location.protocol;
  const newUrl = window.location.href.replace(hostName, currentRegionCode);
  const url = new URL(newUrl, `${protocol}${currentRegionCode}`);
  url.searchParams.set("redirectRegionId", currentRegionId);
  window.location.href = url.toString();
 }

 removeRegionGetParams(query) {
  if (query.has("redirectRegionId")) {
   const url = new URL(window.location.href, window.location.href);
   url.searchParams.delete("redirectRegionId");
   window.history.replaceState(null, "", url);
  }
 }
}
